// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IDomainType, ISetupStepProps } from ".";
import styled from "@emotion/styled";
import * as React from "react";
import { useCallback } from "react";

import { Tickets, World } from "@livechat/design-system-icons";
import { Button, SpacingToken } from "@livechat/design-system-react-components";

import { ButtonGroup } from "components/button/ButtonGroup";
import { EventPlace, trackEngagement } from "helpers/analytics";

import { DomainSetupActionType, SelectTypeAction } from "../DomainSetupModal";

import { SetupDomainFirstStepItem } from "./SetupDomainFirstStepItem";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FirstStepItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(${SpacingToken.Spacing5});
`;

const SetupSelectDomainType: React.FC<ISetupStepProps<SelectTypeAction>> = ({
  domains,
  setModalAction,
  setDomainType,
}) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const helpdeskDomain = domains.find((domain: any) => domain?.name?.endsWith(".helpdesk.com"));

  const handleSetDomainType = (type: IDomainType): void => {
    setDomainType(type);

    if (type === "custom") {
      trackEngagement("Settings: Custom domain creation requested", EventPlace.Settings);
      // @ts-expect-error TS(2322)
      setModalAction({ type: DomainSetupActionType.NewDomain });
    }
    if (type === "helpdesk") {
      trackEngagement("Settings: HelpDesk domain creation requested", EventPlace.Settings);
      // @ts-expect-error TS(2322)
      setModalAction({ type: DomainSetupActionType.HelpdeskDomain });
    }
  };

  return (
    <Wrapper>
      <FirstStepItemsWrapper>
        <SetupDomainFirstStepItem
          disabled={false}
          topText="Add custom domain"
          bottomText="A domain of your choice"
          handleSetDomainType={handleSetDomainType}
          iconSource={World}
          value="custom"
        />
        <SetupDomainFirstStepItem
          disabled={!!helpdeskDomain}
          topText="Add HelpDesk domain"
          bottomText="A domain provided by HelpDesk"
          handleSetDomainType={handleSetDomainType}
          iconSource={Tickets}
          value="helpdesk"
        />
      </FirstStepItemsWrapper>
    </Wrapper>
  );
};

const SetupSelectDomainTypeButtons: React.FC<ISetupStepProps<SelectTypeAction>> = ({ onClose, domainType }) => {
  const handleClose = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      event.preventDefault();
      onClose();
    },
    [onClose]
  );

  return (
    <ButtonGroup>
      <Button size="large" kind="secondary" onClick={handleClose}>
        Cancel
      </Button>
      <Button disabled={domainType === null} size="large" kind="primary" type="submit" form="domain-type-form">
        Next
      </Button>
    </ButtonGroup>
  );
};

export { SetupSelectDomainType, SetupSelectDomainTypeButtons };
